import { inputStyles } from "@store/theme/common/mixins";
import { TYPOGRAPHY } from "@store/theme/design";
import { css } from "styled-components";

export default {
    defaultProps: {
        border: "rounded",
        labelProps: {
            size: TYPOGRAPHY.size.small,
            weight: TYPOGRAPHY.weight.bold,
        },
        errorProps: {
            size: TYPOGRAPHY.size.smallest,
            weight: TYPOGRAPHY.weight.bold,
        },
        hintProps: {
            size: TYPOGRAPHY.size.smallest,
            weight: TYPOGRAPHY.weight.bold,
        },
        cssOverrides: {
            formField: css`
                textarea {
                    ${inputStyles()}
                }
            `,
            inputSelect: css`
                ${inputStyles()}
            `,
            descriptionWrapper: css`
                line-height: ${TYPOGRAPHY.lineHeight.small};
            `,
        },
    },
};
